import classNames from 'classnames';
import * as React from 'react';
import './styles/ModalBoxFooter.scss';

type ModalBoxFooterProps = React.PropsWithChildren<{} & React.HTMLAttributes<HTMLElement>>;

function ModalBoxFooter({ className, children }: ModalBoxFooterProps) {
    const classes = classNames('palette-modal-box-footer', className);

    return (
        <footer className={classes}>
            {children}
        </footer>
    );
}

export default ModalBoxFooter;
